import gmx_zMixins              from '../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support

import lmx_localData            from '../primitives/localData'

import lmx_Events               from './Events'
import lmx_Watching             from './Watching'


import lmx_LocalValues          from './set_LocalValues'
import lmx_draw_Forms           from './draw_Forms'
import lmx_chart_ITRs           from './chart_ITRs'
import lmx_draw_Detail          from './draw_Detail'
import lmx_draw_Refalsh         from './draw_Refalsh'


export default {
  
  mixins: [
    gmx_zMixins,
    lmx_localData,
    
    // Local Mixins
    lmx_Events,
    lmx_Watching,
    
    lmx_LocalValues,
    lmx_draw_Forms,
    lmx_chart_ITRs,
    lmx_draw_Detail,
    lmx_draw_Refalsh,
    
  ],

}
